import { observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';

import { useEffect } from 'react';

class CultureSwiperStore {
  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  swiperStore = new BaseSwiperStore();

  /**
   * 列表
   * @type {[{img: {}, title: string},{img: {}, title: string},{img: {}, title: string}]}
   */
  @observable list = [];

  onClickSwiperGoNext = () => {
    this.swiperStore.goNext();
  };

  onClickSwiperGoPrev = () => {
    this.swiperStore.goPrev();
  };

  use(data) {
    useEffect(
      () => {
        // console.log('CultureSwiperStore', data);
        this.list = data || [];
      },
      [data]
    );
  }
}

export default CultureSwiperStore;
